import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "react-router-dom";
function NavMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [hovered, setHovered] = useState<string | null>(null);
  const socials = [{
    key: "facebook",
    label: "Facebook",
    svg: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
        </svg>
  }, {
    key: "twitter",
    label: "X",
    svg: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
  }, {
    key: "pinterest",
    label: "Pinterest",
    svg: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
        </svg>
  }, {
    key: "whatsapp",
    label: "WhatsApp",
    svg: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
        </svg>
  }, {
    key: "email",
    label: "Email",
    svg: <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
  }];
  return <div className="bg-black border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-stretch min-h-[52px]">
          <div className="flex items-center gap-3 flex-1 py-2">
            <Link to="/" className="flex items-center gap-3">
              <div className="hidden sm:flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-500/30 shrink-0">
                <svg viewBox="0 0 24 24" fill="none" width="16" height="16" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <div className="hidden sm:flex items-center gap-2">
                <span className="text-[10px] font-700 tracking-[0.2em] uppercase text-emerald-400 leading-none">
                  VERIFIED
                </span>
                <div className="w-px h-3 bg-border" />
                <span className="text-[10px] font-700 tracking-[0.2em] uppercase text-muted-foreground leading-none">
                  RANKED
                </span>
              </div>
            </Link>

            <nav className="flex items-center gap-6 ml-8">
              {!loading && menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-[11px] font-700 tracking-widest uppercase text-white hover:text-white transition-colors">
                  {item.label}
                </Link>)}
            </nav>
          </div>

          <div className="flex items-center gap-1 py-2">
            <div className="hidden sm:flex items-center mr-2">
              <span className="text-[10px] tracking-widest uppercase text-muted-foreground/50 font-500">
                Share
              </span>
              <div className="ml-2 w-4 h-px bg-border" />
            </div>
            {socials.map(social => <Button key={social.key} variant="ghost" size="icon" className={`w-8 h-8 rounded-full transition-all duration-200 ${hovered === social.key ? "bg-primary text-primary-foreground scale-110" : "text-muted-foreground hover:text-foreground hover:bg-accent"}`} onMouseEnter={() => setHovered(social.key)} onMouseLeave={() => setHovered(null)} aria-label={social.label}>
                {social.svg}
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}
export default function HeaderSection() {
  return <header id="header" className="dark fixed top-0 left-0 right-0 z-50 w-full">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap');`}</style>
      <MenuProvider menu_id="16">
        <NavMenuContent />
      </MenuProvider>
    </header>;
}